import React from 'react';

export const Datenschutz = () => {
  return (
    <div style={{
      minHeight: '100vh',
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-page)'
    }}>
      <div className="container" style={{ maxWidth: '900px' }}>
        <h1 className="display-medium" style={{ marginBottom: 'var(--spacing-xl)' }}>
          Datenschutzerklärung
        </h1>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            1. Datenschutz auf einen Blick
          </h2>
          <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
            Allgemeine Hinweise
          </h3>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            2. Datenerfassung auf dieser Website
          </h2>
          <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
            Wer ist verantwortlich für die Datenerfassung auf dieser Website?
          </h3>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
          </p>

          <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
            Wie erfassen wir Ihre Daten?
          </h3>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben oder bei der Buchung von Dienstleistungen angeben.
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
          </p>

          <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
            Wofür nutzen wir Ihre Daten?
          </h3>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden oder zur Abwicklung von Verträgen und Dienstleistungen.
          </p>

          <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
            Welche Rechte haben Sie bezüglich Ihrer Daten?
          </h3>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            3. Hosting
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich vor allem um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Webseitenzugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            4. Zahlungsanbieter
          </h2>
          <h3 className="heading-3" style={{ marginBottom: 'var(--spacing-small)' }}>
            PayPal
          </h3>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Auf dieser Website bieten wir die Bezahlung via PayPal an. Anbieter ist die PayPal (Europe) S.à.r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg. Wenn Sie mit PayPal bezahlen, werden die von Ihnen eingegebenen Zahlungsdaten an PayPal übermittelt.
          </p>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Die Übermittlung Ihrer Daten an PayPal erfolgt auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) und Art. 6 Abs. 1 lit. b DSGVO (Verarbeitung zur Erfüllung eines Vertrags).
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            5. Ihre Rechte
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
            Sie haben folgende Rechte:
          </p>
          <ul style={{ marginLeft: '24px', marginBottom: 'var(--spacing-medium)' }}>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Recht auf Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Recht auf Berichtigung unrichtiger Daten
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Recht auf Löschung Ihrer bei uns gespeicherten Daten
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Recht auf Einschränkung der Datenverarbeitung
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Recht auf Datenübertragbarkeit
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Recht auf Widerruf einer erteilten Einwilligung
            </li>
            <li className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
              Recht auf Beschwerde bei einer Aufsichtsbehörde
            </li>
          </ul>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Zur Ausübung Ihrer Rechte wenden Sie sich bitte an die im Impressum angegebene Kontaktadresse.
          </p>
        </section>

        <section style={{ marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="heading-2" style={{ marginBottom: 'var(--spacing-medium)' }}>
            6. Kontaktformular und E-Mail-Kontakt
          </h2>
          <p className="body-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>
        </section>

        <p className="body-medium" style={{ fontStyle: 'italic', color: 'var(--text-light)' }}>
          Stand: Januar 2025
        </p>
      </div>
    </div>
  );
};
